import * as React from 'react';
import Page from './Page';
import ReportAssignmentCore from './core/ReportAssignmentCore';
import { TaxonomyTypeEnum } from '../redux/TaxonomyVersionSlice';




const AFRAssignment = (props: any) => {
    return (
        <React.Fragment>
            <Page>
                <ReportAssignmentCore taxonomyType={TaxonomyTypeEnum.AFR} />
            </Page>
        </React.Fragment>
    );
}

export default AFRAssignment;